import api from "./config"; // tu axios preconfigurado

// 1) Pedir presigned URL para HISTORIA CLÍNICA
export async function getPresignedUrlHistoria(historiaId, file) {
  const resp = await api.post("/historias-clinicas/labs/presign-upload/", {
    historia_id: historiaId,
    filename: file.name,
    content_type: file.type,
  });

  return resp.data; // { key, upload_url }
}

// 2) PUT directo a S3
export async function putFileToS3(uploadUrl, file) {
  
  const resp = await fetch(uploadUrl, {
    method: "PUT",
    headers: {
      "Content-Type": file.type,
    },
    body: file,
  });

  if (!resp.ok) {
    throw new Error("Error subiendo archivo a S3");
  }
}

// 3) Confirmar subida y registrar en BD
export async function confirmUploadHistoria(historiaId, key, file, descripcion = "") {
  const resp = await api.post("/historias-clinicas/labs/confirm-upload/", {
    historia_id: historiaId,
    key: key,
    nombre: file.name,
    descripcion: descripcion,
  });

  return resp.data;
}

// 4) Presigned URL para CONSULTA
export async function getPresignedUrlConsulta(consultaId, file) {
  const resp = await api.post("/consultas/labs/presign-upload/", {
    consulta_id: consultaId,
    filename: file.name,
    content_type: file.type,
  });

  return resp.data; // { key, upload_url }
}

// 5) Confirmar subida de archivo de CONSULTA
export async function confirmUploadConsulta(consultaId, key, file, descripcion = "") {
  const resp = await api.post("/consultas/labs/confirm-upload/", {
    consulta_id: consultaId,
    key: key,
    nombre: file.name,
    descripcion: descripcion,
  });

  return resp.data;
}

// ==========================================================
// 6) PRESIGNED GET (DESCARGA) — NUEVO
// ==========================================================

//  6.1 Obtener presigned GET para HISTORIA CLÍNICA
export async function getPresignedGetUrlHistoria(historiaId, fileKey) {
  const resp = await api.post("/historias-clinicas/labs/presign-download/", {
    historia_id: historiaId,
    key: fileKey,
  });

  return resp.data.url;
}

//  6.2 Obtener presigned GET para CONSULTA
export async function getPresignedGetUrlConsulta(consultaId, fileKey) {
  const resp = await api.post("/consultas/labs/presign-download/", {
    consulta_id: consultaId,
    key: fileKey,
  });

  return resp.data.url;
}

// 6.3 Abrir URL presignada (en nueva pestaña, seguro)
export function openPresignedUrl(url) {
  window.open(url, "_blank", "noopener,noreferrer");
}
